import React from 'react';

const AddonTitle = ({ record }) => {
	return <span>Addon {record ? `"${record.name}"` : ''}</span>;
};

export default AddonTitle;
